__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-document-center'].baseUrl;
import ModuleContainer from './components/DocumentCenter';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/product-ducks': '^1.0.7'
    }
  });
}